module.exports = __webpack_public_path__ + "media/images/athletes/2636-3c7bd3138c06a3c12e165cb1c79e148c.png";